// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger-btn {
  display: none;
  position: fixed;
  top: 18px;
  left: 18px;
  z-index: 1201;
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.18s, border 0.18s;
}

.hamburger-btn:active, .hamburger-btn:focus, .hamburger-btn:hover {
  background: transparent;
  border: none;
  box-shadow: none;
}

.hamburger-icon {
  display: block;
  width: 24px;
  height: 3px;
  background: #2F80ED;
  border-radius: 2px;
  position: relative;
}

.hamburger-icon::before, .hamburger-icon::after {
  content: '';
  display: block;
  width: 24px;
  height: 3px;
  background: #2F80ED;
  border-radius: 2px;
  position: absolute;
  left: 0;
  transition: 0.2s;
}

.hamburger-icon::before {
  top: -8px;
}

.hamburger-icon::after {
  top: 8px;
}

.show-on-mobile {
  display: none;
}

@media (max-width: 900px) {
  .hamburger-btn {
    display: block;
  }
  
  .show-on-mobile {
    display: block;
  }
}

@media (max-width: 600px) {
  .hamburger-btn {
    top: 8px;
    left: 8px;
    padding: 8px 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/MobileMenu/MobileMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,iBAAiB;EACnB;AACF","sourcesContent":[".hamburger-btn {\n  display: none;\n  position: fixed;\n  top: 18px;\n  left: 18px;\n  z-index: 1201;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 12px;\n  cursor: pointer;\n  box-shadow: none;\n  transition: background 0.18s, border 0.18s;\n}\n\n.hamburger-btn:active, .hamburger-btn:focus, .hamburger-btn:hover {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.hamburger-icon {\n  display: block;\n  width: 24px;\n  height: 3px;\n  background: #2F80ED;\n  border-radius: 2px;\n  position: relative;\n}\n\n.hamburger-icon::before, .hamburger-icon::after {\n  content: '';\n  display: block;\n  width: 24px;\n  height: 3px;\n  background: #2F80ED;\n  border-radius: 2px;\n  position: absolute;\n  left: 0;\n  transition: 0.2s;\n}\n\n.hamburger-icon::before {\n  top: -8px;\n}\n\n.hamburger-icon::after {\n  top: 8px;\n}\n\n.show-on-mobile {\n  display: none;\n}\n\n@media (max-width: 900px) {\n  .hamburger-btn {\n    display: block;\n  }\n  \n  .show-on-mobile {\n    display: block;\n  }\n}\n\n@media (max-width: 600px) {\n  .hamburger-btn {\n    top: 8px;\n    left: 8px;\n    padding: 8px 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
